<!-- Price -->
<template>
  <div class="Price">
    <HelloWorld />
    <div class="articletu">
      <img src="../assets/image/banner6.png" alt />
    </div>
    <h2 class="h2a">智选云商新版会员</h2>
    <div class="atable" style="height: 402px;">
      <table>
        <thead>
        <tr>
          <th class="tab1">大类</th>
          <th class="tab2">模块</th>
          <th class="tab3">收费方式</th>
          <th class="tab4">收费标准</th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td class="tab1">基础设置</td>
          <td class="tab2 dis1">
            <span>授权管理</span>
            <span>权益管理</span>
          </td>
          <td class="tab3" rowspan="11">小企业无限试用</td>
          <td class="tab4" rowspan="11">
            0
          </td>
        </tr>
        <tr class="back">
          <td class="tab1">会员数据</td>
          <td class="tab2 dis1">
            <span>会员复购</span>
            <span>增长流失</span>
            <span>健康状况</span>
          </td>
        </tr>
        <tr>
          <td class="tab1">会员营销</td>
          <td class="tab2 dis1">
            <span>优惠券</span>
            <span>大转盘</span>
          </td>
        </tr>
        <tr class="back">
          <td class="tab1">会员储值</td>
          <td class="tab2">
            <span>会员储值</span>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <h2 class="h2a">智选云商体验版</h2>
    <div class="atable" style="height: 402px;">
      <table>
        <thead>
        <tr>
          <th class="tab1">大类</th>
          <th class="tab2">模块</th>
          <th class="tab3">收费方式</th>
          <th class="tab4">收费标准</th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td class="tab1">基础设置</td>
          <td class="tab2 dis1">
            <span>基础管理</span>
            <span>商品管理</span>
          </td>
          <td class="tab3" rowspan="11">小企业无限试用</td>
          <td class="tab4" rowspan="11">
           0
          </td>
        </tr>
        <tr class="back">
          <td class="tab1">采购</td>
          <td class="tab2">采购管理</td>
        </tr>
        <tr>
          <td class="tab1">批发</td>
          <td class="tab2">批发业务</td>
        </tr>
        <tr class="back">
          <td class="tab1">零售</td>
          <td class="tab2">
            <span>零售/收银</span>
          </td>
        </tr>
        <tr>
          <td class="tab1">报表</td>
          <td class="tab2">
            <span>库存类</span>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <h2 class="h2a">智选云商零售版</h2>
    <div class="atable">
      <table>
        <thead>
          <tr>
            <th class="tab1">大类</th>
            <th class="tab2">模块</th>
            <th class="tab3">收费方式</th>
            <th class="tab4">收费标准</th>
          </tr>
        </thead>
        <tbody>
          <tr class="hei1">
            <td class="tab1">基础设置</td>
            <td class="tab2 dis1">
              <span>基础管理</span>
              <span>商品管理</span>
              <span>期初管理</span>
              <span>流程配置</span>
              <span>系统设置</span>
            </td>
            <td class="tab3" rowspan="11">按店收费</td>
            <td class="tab4" rowspan="11">
              <h3 class="h31">
                <span>1800</span>/年/店
              </h3>
              <p class="p1">2年收费标准=1年收费标准×2</p>
              <p class="p1">3年收费标准=1年收费标准×3</p>
            </td>
          </tr>
          <tr class="back">
            <td class="tab1">采购</td>
            <td class="tab2">采购管理</td>
          </tr>
          <tr>
            <td class="tab1">批发</td>
            <td class="tab2">批发业务</td>
          </tr>
          <tr class="back">
            <td class="tab1">零售</td>
            <td class="tab2 dis2">
              <span>零售/收银</span>
              <span>门店管理</span>
              <span>增值业务</span>
            </td>
          </tr>
          <tr>
            <td class="tab1">仓库</td>
            <td class="tab2 dis3">
              <span>调拨</span>
              <span>仓库管理</span>
              <span>售后</span>
            </td>
          </tr>
          <tr class="back">
            <td class="tab1">串号</td>
            <td class="tab2">串号查询</td>
          </tr>
          <tr>
            <td class="tab1">价保返利</td>
            <td class="tab2">价保单/返利单</td>
          </tr>
          <tr class="back">
            <td class="tab1">报表</td>
            <td class="tab2 dis3">
              <span>库存类</span>
              <span>业务类</span>
              <span>经营类</span>
            </td>
          </tr>
          <tr class="hei2">
            <td class="tab1">会员管理</td>
            <td class="tab2 dis4">
              <span>基础设置</span>
              <span>会员管理</span>
              <span>会员营销</span>
              <span>店效管理</span>
              <span>会员中心</span>
              <span>会员消息</span>
              <span>客户管理</span>
            </td>
          </tr>
          <tr class="back">
            <td class="tab1">零售APP</td>
            <td class="tab2 dis3">
              <span>门店零售</span>
              <span>客户管理</span>
              <span>进销存</span>
            </td>
          </tr>
          <tr class="hei3">
            <td class="tab1">B2c商城</td>
            <td class="tab2 dis1">
              <span>热卖</span>
              <span>会员</span>
              <span>广告</span>
              <span>优惠券</span>
              <span>满减</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <h2 class="h2a">智选云商分销版</h2>
    <div class="btable">
      <table>
        <thead>
          <tr>
            <th class="tab1">大类</th>
            <th class="tab2">模块</th>
            <th class="tab3">收费方式</th>
            <th class="tab4">收费标准</th>
          </tr>
        </thead>
        <tbody>
          <tr class="hei1">
            <td class="tab1">基础设置</td>
            <td class="tab2 dis1">
              <span>审核设置</span>
              <span>短信设置</span>
              <span>专属页面配置</span>
              <span>支付配置</span>
            </td>
            <td class="tab3" rowspan="8">按套收费</td>
            <td class="tab4" rowspan="8">
              <h3 class="h31">
                <span>15800</span>/年/套
              </h3>
              <p class="p1">2年收费标准=1年收费标准×2</p>
              <p class="p1">3年收费标准=1年收费标准×3</p>
            </td>
          </tr>
          <tr class="back">
            <td>电商商品管理</td>
            <td class="dis2">
              <span>商品分类</span>
              <span>商品信息</span>
              <span>商品管理</span>
            </td>
          </tr>
          <tr>
            <td>客户管理</td>
            <td class="dis2">
              <span>客户拓展</span>
              <span>客户管理</span>
            </td>
          </tr>
          <tr class="back">
            <td>渠道管理</td>
            <td class="dis2">
              <span>多维度价格</span>
              <span>返利/保价</span>
              <span>区域定向</span>
            </td>
          </tr>
          <tr>
            <td>交易/订单</td>
            <td class="dis2">
              <span>订单支付</span>
              <span>订单状态</span>
              <span>订单管理</span>
            </td>
          </tr>
          <tr class="hei1 back">
            <td>营销活动</td>
            <td class="dis3">
              <span>商城头条</span>
              <span>捆绑售卖</span>
              <span>售卖规则</span>
              <span>首页轮播广告</span>
            </td>
          </tr>
          <tr>
            <td>报表</td>
            <td class="dis2">
              <span>收支报表</span>
              <span>批发报表</span>
            </td>
          </tr>
          <tr class="back">
            <td>订货端口</td>
            <td class="dis2">
              <span>订货PC</span>
              <span>订货小程序</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <h2 class="h2a">可选增值服务</h2>
    <div class="ctable">
      <p>限时优惠至2020年12月31日</p>
      <table>
        <thead>
          <tr>
            <th class="tab1">服务名称</th>
            <th class="tab2">价格</th>
            <th class="tab3">备注</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>上门实施</td>
            <td class="jsge"><span>1000</span><s>2000</s>元/人/天</td>
            <!-- <td><p><span>1000</span><s>2000</s>元/人/天 </p></td> -->
            <td>不含差旅费</td>
          </tr>
           <tr class="back">
            <td>在线实施</td>
            <td class="jsge"><span>58</span><s>198</s>元/小时</td>
            <td>不足1小时，按1小时计算</td>
          </tr>
        </tbody>
      </table>
    </div>
    <Footer />
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import HelloWorld from "@/components/top-header";
import Footer from "@/components/footer";

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    HelloWorld,
    Footer,
  },
  data() {
    //这里存放数据
    return {};
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.articletu {
  width: 100%;
   margin-top: 70px;
  // height: 300px;
  // border: 1px solid black;
  // margin: 0px auto;
  img {
    width: 100%;
    // height: 300px;
  }
}
.h2a {
  color: #333333;
  font-size: 32px;
  text-align: center;
  margin-top: 63px;
  margin-bottom: 30px;
}
.atable {
  width: 1100px;
  height: 900px;
  // border: 1px solid red;
  margin: 0px auto;
  table {
    width: 100%;
    border: 1px solid #e6e9ed;
    border-spacing: 0;
    text-align: center;
    empty-cells: show;
    caption-side: right;

    tr {
      width: 100%;
      th {
        border: 1px solid #e6e9ed;
        font-size: 18px;
        color: #6e7682;
        text-align: center;
        height: 64px;
        background-color: #eff4fd;
      }
      td {
        border: 1px solid #e6e9ed;
        font-size: 16px;
        color: #6e7682;
        text-align: center;
        height: 64px;
      }
      .p1 {
        color: #bbbbbb;
        font-size: 12px;
      }
      .h31 {
        line-height: 30px;
        color: #6e7682;
        font-size: 16px;
        span {
          color: #3366ff;
          font-size: 30px;
        }
      }
      .tab1 {
        width: 260px;
      }
      .tab2 {
        width: 390px;
      }
      .tab3 {
        width: 193px;
      }
      .tab4 {
        width: 260px;
      }
    }
    .back {
      background-color: #f8f8f8;
    }
    .hei1 {
      height: 94px;
    }
    .hei2 {
      height: 120px;
    }
    .hei3 {
      height: 94px;
    }
    .dis1 {
      height: 60px;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      border: 0px;
      margin-top: 20px;
      // justify-content:center;
      span {
        width: 33%;
        height: 30%;
        line-height: 30px;
      }
    }
    .dis2 {
      height: 64px;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      border: 0px;
      // margin-top: 20px;
      // justify-content:center;
      span {
        width: 33%;
        height: 90%;
        line-height: 65px;
      }
    }
    .dis3 {
      height: 64px;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      // border: 0px;
      // margin-top: 20px;
      // justify-content:center;
      span {
        width: 33%;
        height: 90%;
        line-height: 65px;
      }
    }
    .dis4 {
      height: 100px;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      border: 0px;
      margin-top: 10px;
      // justify-content:center;
      span {
        width: 33%;
        height: 25%;
        line-height: 25px;
      }
    }
  }
}
.btable {
  width: 1100px;
  height: 650px;
  // border: 1px solid red;
  margin: 0px auto;
  table {
    width: 100%;
    border: 1px solid #e6e9ed;
    border-spacing: 0;
    text-align: center;
    empty-cells: show;
    caption-side: right;

    tr {
      width: 100%;
      th {
        border: 1px solid #e6e9ed;
        font-size: 18px;
        color: #6e7682;
        text-align: center;
        height: 64px;
        background-color: #eff4fd;
      }
      td {
        border: 1px solid #e6e9ed;
        font-size: 16px;
        color: #6e7682;
        text-align: center;
        height: 64px;
      }
      .p1 {
        color: #bbbbbb;
        font-size: 12px;
      }
      .h31 {
        line-height: 30px;
        color: #6e7682;
        font-size: 16px;
        span {
          color: #3366ff;
          font-size: 30px;
        }
      }
      .tab1 {
        width: 260px;
      }
      .tab2 {
        width: 390px;
      }
      .tab3 {
        width: 193px;
      }
      .tab4 {
        width: 260px;
      }
      .dis1 {
        margin-top: 20px;
        height: 60px;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        border: 0px;
        // justify-content:center;
        span {
          width: 49%;
          height: 40%;
          line-height: 30px;
        }
      }
      .dis2 {
        height: 64px;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        border: 0px;
        border-top: 1px solid #e6e9ed;
        // justify-content:center;
        span {
          width: 33%;
          height: 64px;
          line-height: 64px;
        }
      }
      .dis3 {
        height: 80px;
        // margin-top: 20px;
        padding-top: 10px;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        border: 0px;
        border-top: 1px solid #e6e9ed;
        // justify-content:center;
        span {
          width: 33%;
          height: 50%;
          line-height: 40px;
        }
      }
    }
    .back {
      background-color: #f8f8f8;
    }
    .hei1 {
      height: 94px;
    }
  }
}
.ctable {
  width: 1100px;
  height: 260px;
  // border: 1px solid red;
  margin: 0px auto;
  margin-bottom: 150px;
  p {
    text-align: right;
    color: #fc2b2b;
    font-size: 12px;
    margin-bottom: 30px;
  }
  table {
    width: 100%;
    border: 1px solid #e6e9ed;
    border-spacing: 0;
    text-align: center;
    empty-cells: show;
    caption-side: right;
    tr {
      width: 100%;
      th {
        border: 1px solid #e6e9ed;
        font-size: 18px;
        color: #6e7682;
        text-align: center;
        height: 64px;
        background-color: #eff4fd;
      }
      td {
        border: 1px solid #e6e9ed;
        font-size: 16px;
        color: #6e7682;
        text-align: center;
        height: 64px;
      }
      .p1 {
        color: #bbbbbb;
        font-size: 12px;
      }
      .h31 {
        line-height: 30px;
        color: #6e7682;
        font-size: 16px;
        span {
          color: #3366ff;
          font-size: 30px;
        }
      }
      .jsge{
        font-size: 16px;
        color: #6E7682;
        span{
          color: #FB9F00;
          font-size: 30px;
        }
      }
      .tab1 {
        width: 260px;
      }
      .tab2 {
        width: 390px;
      }
      .tab3 {
        width: 452px;
      }
    }
    .back {
      background-color: #f8f8f8;
    }
    
  }
}
@media screen and (max-width: 1200px) {
  .Price {
    width: 1200px;
    // border: 1px solid black;
    // height: 560px;
  }
}
</style>